import Vue from 'vue';
import Router from 'vue-router';
import Huasi from '@/components/Huasi';
import Home from '@/views/Home/index';

Vue.use(Router);

export default new Router({
  routes: [
    {
      // 云平台首页
      path: '/',
      component: Home,
      name: 'index',
      meta: {
        requireAuth: true,
        title: '云平台首页',
      },
    },
    {
      path: '/v2',
      component: Huasi,
      meta: {
        requireAuth: true,
      },
      children: [
        {
          // 项目首页
          path: '',
          name: 'home',
          meta: {
            componentName: 'Home',
            keepOnchange: true, // changeProject时保留在tab中
            title: '项目首页',
          },
        },
        // ------------------------------------------------------------------- 项目相关
        {
          // 项目管理
          path: 'projects',
          name: 'projects',
          meta: {
            componentName: 'Projects',
            keepOnchange: true,
            title: '项目管理',
          },
          children: [
            // 新建项目
            {
              path: 'new',
              name: 'new',
              meta: {
                componentName: 'ProjectNew',
                title: '新建项目',
              },
            },
            {
              path: ':projectId',
              name: 'deviceManagement',
              meta: {
                componentName: 'Project',
                title: '设备管理',
              },
            },
            {
              path: ':projectId/edit',
              name: 'editProject',
              meta: {
                componentName: 'ProjectEdit',
                title: '编辑项目',
              },
            },
          ],
        },
        {
          path: 'branches',
          name: 'groupSetting',
          meta: {
            componentName: 'Branch',
            needSuperAdmin: true,
            title: '分组设置',
          },
        },
        {
          path: 'warning-management',
          name: 'warning-management',
          meta: {
            componentName: 'WarningManagement',
            needSuperAdmin: true,
            title: '险情处理',
          },
        },
        {
          path: 'devicetest',
          name: 'devicetest',
          meta: {
            componentName: 'Test',
            title: '设备测试',
          },
        },
        {
          path: 'cluster-setting',
          name: 'cluster-setting',
          meta: {
            componentName: 'ClusterSetting',
            needSuperAdmin: true,
            title: '集群设置',
          },
        },
        {
          path: 'cluster-chart',
          name: 'cluster-chart',
          meta: {
            componentName: 'ClusterChart',
            title: '集群测量',
          },
        },
        // ------------------------------------------------------------------- 采集记录相关
        {
          path: 'adm-collections/device/:deviceId',
          name: 'adm-collections',
          meta: {
            componentName: 'AdmCollection',
            title: '采集记录',
          },
        },
        {
          path: 'sdm-collections/device/:deviceId',
          name: 'sdm-collections',
          meta: {
            componentName: 'SdmCollection',
            title: '位移计采集记录',
          },
        },
        {
          path: 'sdmx-collections/device/:deviceId',
          name: 'sdmx-collections',
          meta: {
            componentName: 'SdmxCollection',
            title: '振动采集记录',
          },
        },
        {
          path: 'sdmpro-collections/device/:deviceId',
          name: 'sdmpro-collections',
          meta: {
            componentName: 'SdmproCollection',
            title: '振动位移计采集记录',
          },
        },
        {
          path: 'hda2-collections/device/:deviceId',
          name: 'hda2-collections',
          meta: {
            componentName: 'Hda2Collection',
            title: '渗压计采集记录',
          },
        },
        {
          path: 'hda3-collections/device/:deviceId',
          name: 'hda3-collections',
          meta: {
            componentName: 'Hda3Collection',
            title: '水位计采集记录',
          },
        },
        {
          path: 'hda4-collections/device/:deviceId',
          name: 'hda4-collections',
          meta: {
            componentName: 'Hda4Collection',
            title: '测缝计采集记录',
          },
        },
        {
          path: 'hda5-collections/device/:deviceId',
          name: 'hda5-collections',
          meta: {
            componentName: 'Hda5Collection',
            title: '锚索计采集记录',
          },
        },
        {
          path: 'hda6-collections/device/:deviceId',
          name: 'hda6-collections',
          meta: {
            componentName: 'Hda6Collection',
            title: '钢筋计采集记录',
          },
        },
        {
          path: 'hda7-collections/device/:deviceId',
          name: 'hda7-collections',
          meta: {
            componentName: 'Hda7Collection',
            title: '应变计采集记录',
          },
        },
        {
          path: 'hda8-collections/device/:deviceId',
          name: 'hda8-collections',
          meta: {
            componentName: 'Hda8Collection',
            title: '轴力计采集记录',
          },
        },
        {
          path: 'collections/:collectionId/details',
          name: 'collections',
          meta: {
            componentName: 'Detail',
            title: '节点数据',
          },
        },
        {
          path: 'union-value/:type/:sn',
          name: 'unionValue',
          meta: {
            componentName: 'UnionValue',
            title: '通道组合',
          },
        },
        // ------------------------------------------------------------------- 图表相关
        {
          path: 'adm-chart/device/:deviceId',
          name: 'adm-chart',
          meta: {
            componentName: 'AdmChart',
            title: '分量图',
          },
        },
        {
          path: 'sdm-chart/device/:deviceId',
          name: 'sdm-chart',
          meta: {
            componentName: 'SdmChart',
            title: '单点分量图',
          },
        },
        {
          path: 'hda2-chart/device/:deviceId',
          name: 'hda2-chart',
          meta: {
            componentName: 'Hda2Chart',
            title: '渗压计分量图',
          },
        },
        {
          path: 'hda3-chart/device/:deviceId',
          name: 'hda3-chart',
          meta: {
            componentName: 'Hda3Chart',
            title: '水位计分量图',
          },
        },
        {
          path: 'hda4-chart/device/:deviceId',
          name: 'hda4-chart',
          meta: {
            componentName: 'Hda4Chart',
            title: '测缝计分量图',
          },
        },
        {
          path: 'hda5-chart/device/:deviceId',
          name: 'hda5-chart',
          meta: {
            componentName: 'Hda5Chart',
            title: '锚索计分量图',
          },
        },
        {
          path: 'hda6-chart/device/:deviceId',
          name: 'hda6-chart',
          meta: {
            componentName: 'Hda6Chart',
            title: '钢筋计计分量图',
          },
        },
        {
          path: 'hda7-chart/device/:deviceId',
          name: 'hda7-chart',
          meta: {
            componentName: 'Hda7Chart',
            title: '应变计分量图',
          },
        },
        {
          path: 'hda8-chart/device/:deviceId',
          name: 'hda8-chart',
          meta: {
            componentName: 'Hda8Chart',
            title: '轴力计分量图',
          },
        },
        {
          path: 'sdmx-chart/device/:deviceId',
          name: 'sdmx-chart',
          meta: {
            componentName: 'SdmxChart',
            title: '振动历史图',
          },
        },
        {
          path: 'sdmx-real-time-chart/device/:deviceId',
          name: 'sdmx-real-time-chart',
          meta: {
            componentName: 'SdmxRealTimeChart',
            title: '振动实时图',
          },
        },
        {
          path: 'sdmpro-tilt-chart/device/:deviceId',
          name: 'sdmpro-tilt-chart',
          meta: {
            componentName: 'SdmproTiltChart',
            title: '倾角监测图',
          },
        },
        {
          path: 'sdmpro-vibr-chart/device/:deviceId',
          name: 'sdmpro-vibr-chart',
          meta: {
            componentName: 'SdmproVibrChart',
            title: '振动监测图',
          },
        },
        {
          path: 'profiles-3d/device/:deviceId',
          name: 'profiles-3d',
          meta: {
            componentName: 'Profile3d',
            title: '三维图',
          },
        },
        {
          path: 'profiles/device/:deviceId',
          name: 'profiles',
          meta: {
            componentName: 'Profile',
            title: '剖面图',
          },
        },
        {
          path: 'coordinates/device/:deviceId',
          name: 'coordinates',
          meta: {
            componentName: 'Coordinate',
            title: '方位图',
          },
        },
        {
          path: 'anti-twist/device/:deviceId',
          name: 'anti-twist',
          meta: {
            componentName: 'AntiTwist',
            title: '扭转校正',
          },
        },
        {
          path: 'anti-jitter/device/:deviceId',
          name: 'anti-jitter',
          meta: {
            componentName: 'AntiJitter',
            title: '移位校正',
          },
        },
        {
          path: 'jitters/device/:deviceId',
          name: 'jitters',
          meta: {
            componentName: 'AntiJitterList',
            title: '移位校正记录',
          },
        },
        {
          path: 'data-jump/:deviceId',
          name: 'data-jump',
          meta: {
            componentName: 'DataJump',
            title: '数据跳变修正记录',
          },
        },
        {
          path: 'tunnels',
          name: 'tunnels',
          meta: {
            componentName: 'Tunnel',
            title: '隧道收敛图',
          },
        },
        {
          path: 'equipmentHealth/device/:deviceId',
          name: 'equipmentHealth',
          meta: {
            componentName: 'EquipmentHealth',
            title: '设备健康统计',
          },
        },
        // ------------------------------------------------------------------- 状态表相关
        {
          path: 'state/device/:deviceId',
          name: 'state',
          meta: {
            componentName: 'State',
            title: '状态表',
          },
        },
        {
          path: 'motestate',
          name: 'motestate',
          meta: {
            componentName: 'MoteState',
            title: 'Mote状态表',
          },
        },
        {
          path: 'admins',
          name: 'admins',
          meta: {
            componentName: 'AdminList',
            needSuperAdmin: true,
            title: '账号管理',
          },
        },
        {
          path: 'settings',
          name: 'settings',
          meta: {
            componentName: 'Setting',
            needSuperAdmin: true,
            title: '系统设置',
          },
        },
        {
          path: 'inner-settings',
          name: 'inner-settings',
          meta: {
            componentName: 'InnerSetting',
            title: '生产设置',
          },
        },
        {
          path: 'lab',
          name: 'lab',
          meta: {
            componentName: 'Lab',
            needSuperAdmin: true,
            title: '数据实验室',
          },
        },
        {
          path: 'missing-insert/device/:deviceId',
          name: 'missing-insert',
          meta: {
            componentName: 'MissingInsert',
            needSuperAdmin: true,
            title: '补漏记录',
          },
        },
        {
          path: 'pointInfo',
          name: 'pointInfo',
          meta: {
            componentName: 'PointInfo',
            title: '测点信息表',
          },
        },
      ],
    },
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "loginView" */'@/components/login/Login'),
      name: '登录',
    },
    {
      path: '*',
      component: () => import('@/views/404'),
      name: '404 Not Found',
    },
  ],
});

